export const LOGIN_SIDE_IMAGE_URL =
  "https://storage.googleapis.com/ewitness-assets/branding/citybg.png";
